import { render, staticRenderFns } from "./RecallIcon.vue?vue&type=template&id=ac9e84c4"
import script from "./RecallIcon.vue?vue&type=script&lang=js"
export * from "./RecallIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports